.se-container-wide {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}

@media screen and (min-width: 980px) {
  .se-container-wide {
    padding-left: 10px;
    padding-right: 10px;
  }
}

.subcategories__listing {
  display: block;
  margin: 0 auto;
  box-sizing: border-box;
  max-width: 1200px;
  overflow: visible;
  color: #626469;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  background-color: #fafafa;
}

.subcategories__listing *,
.subcategories__listing *::before,
.subcategories__listing *::after {
  box-sizing: inherit;
}

.subcategories__listing *,
.subcategories__listing *::before,
.subcategories__listing *::after {
  box-sizing: inherit;
}

@media screen and (min-width: 980px) {
  .subcategories__listing {
    padding: 0 10px;
    display: grid;
    grid-template-columns: minmax(260px, 300px) minmax(690px, 880px);
    grid-template-rows: auto auto;
  }
}

.subcategories__banner-container--prerender {
  min-height: 110px;
}

.subcategories__banner-container {
  grid-column: 2/3;
  grid-row: 1/2;
}

@media screen and (min-width: 980px) {
  .subcategories__banner-container {
    margin-top: 40px;
  }
}

.subcategories__banner-container:not(:empty) {
  margin-bottom: 12px;
}

.subcategories__aside-filters {
  padding: 0 16px 16px;
}

@media screen and (min-width: 980px) {
  .subcategories__aside-filters {
    padding-left: 0;
    padding-right: 0;
    grid-column: 1/2;
    grid-row: 1/3;
  }

  :host(:not([dir="rtl"])) .subcategories__aside-filters {
    margin-right: 20px;
  }

  :host([dir="rtl"]) .subcategories__aside-filters {
    margin-left: 20px;
  }
}

@media screen and (min-width: 980px) {
  .subcategories__category-wrapper {
    width: 100%;
    min-width: 650px;
    max-width: 900px;
    min-height: 300px;
    grid-column: 2/3;
    grid-row: 2/3;
  }
}